import { Box, Typography } from '@mui/material'
import type { BreadcrumbsProps } from '@mui/material/Breadcrumbs'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { ContainerCustom } from '../container-custom'
import { Fragment } from 'react'
import { Link, TypeLink } from '@/libs/i18n/routing'

// Một item đơn lẻ trong breadcrumb
type TSingleItem = { link?: string; label: string }
// Một cấp có thể chứa một item hoặc nhiều items (hiển thị cách nhau bằng dấu phẩy)
type TContentItem = TSingleItem | TSingleItem[]

export type CustomBreadcrumbsSlots = {
  breadcrumbs?: React.ReactNode
}
type TProps = {
  contents: TContentItem[]
  slotProps?: Partial<CustomBreadcrumbsSlotProps>
  includeContainer?: boolean
  removeContainer?: boolean
}
export type CustomBreadcrumbsSlotProps = {
  breadcrumbs: BreadcrumbsProps
  // content: React.ComponentProps<typeof BreadcrumbsContent>
  // container: React.ComponentProps<typeof BreadcrumbsContainer>
}

export const Breadcrumb = ({ contents, slotProps, removeContainer = false }: TProps) => {
  const BreadcrumbsItem = ({ includeContainer = true }: { includeContainer?: boolean }) => {
    const Component = includeContainer ? ContainerCustom : Box
    const props = includeContainer ? { component: 'div', sx: { py: 1.5, margin: '0 auto' } } : ({} as any)
    return (
      <Component {...props}>
        <Breadcrumbs
          component={'nav'}
          separator={
            <Box
              sx={{
                height: '5px',
                width: '5px',
                background: 'rgba(0,0,0,0.25)',
                borderRadius: '100px',
              }}
            />
          }
          aria-label="breadcrumb"
          sx={{
            '& .MuiBreadcrumbs-ol': {
              rowGap: '.2em',
            },
          }}
          {...slotProps?.breadcrumbs}
        >
          {contents?.map((item: TContentItem, index: number) => {
            const isLastLevel = index + 1 === contents.length

            // Nếu item là array (nhiều items cùng cấp)
            if (Array.isArray(item)) {
              return (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
                  {item.map((subItem, subIndex) => {
                    return (
                      <Fragment key={`${index}-${subIndex}`}>
                        {subItem?.link ? (
                          <Link href={subItem.link as TypeLink}>
                            <Typography
                              sx={{
                                color: 'primary.main',
                                fontSize: { xs: '12px', sm: '14px' },
                                fontWeight: isLastLevel ? 500 : 300,
                                lineHeight: '1.5',
                                ':hover': { textDecoration: 'underline' },
                              }}
                            >
                              {subItem?.label}
                            </Typography>
                          </Link>
                        ) : (
                          <Typography
                            sx={{
                              color: 'primary.main',
                              fontSize: { xs: '12px', sm: '14px' },
                              fontWeight: isLastLevel ? 500 : 300,
                              lineHeight: '1.5',
                            }}
                          >
                            {subItem?.label}
                          </Typography>
                        )}
                        {/* Thêm dấu phẩy giữa các items cùng cấp */}
                        {subIndex < item.length - 1 && (
                          <Typography
                            component="span"
                            sx={{
                              color: 'primary.main',
                              fontSize: { xs: '12px', sm: '14px' },
                              fontWeight: isLastLevel ? 500 : 300,
                            }}
                          >
                            ,
                          </Typography>
                        )}
                      </Fragment>
                    )
                  })}
                </Box>
              )
            }

            // Nếu item là object đơn lẻ (giữ nguyên logic cũ)
            if (isLastLevel) {
              return item?.link ? (
                <Link key={index} href={item.link as TypeLink}>
                  <Typography
                    sx={{
                      color: 'primary.main',
                      fontSize: '14px',
                      fontWeight: 500,
                      ':hover': { textDecoration: 'underline' },
                    }}
                  >
                    {item?.label}
                  </Typography>
                </Link>
              ) : (
                <Typography
                  key={index}
                  sx={{
                    color: 'primary.main',
                    fontSize: '14px',
                    fontWeight: 500,
                  }}
                >
                  {item?.label}
                </Typography>
              )
            }

            return (
              <Link
                href={(item?.link || '/') as TypeLink}
                // underline="hover"
                key={index + 1}
                color="inherit"
              >
                <Typography
                  sx={{
                    fontSize: { xs: '12px', sm: '14px' },
                    color: 'primary.main',
                    fontWeight: 300,
                    lineHeight: '1.5',
                    ':hover': { textDecoration: 'underline' },
                  }}
                >
                  {item?.label}
                </Typography>
              </Link>
            )
          })}
        </Breadcrumbs>
      </Component>
    )
  }
  // if (includeContainer) {
  //   return (
  //     <ContainerCustom maxWidth="xxl" component="main" sx={{ p: 2, margin: '0 auto', pb: 1 }}>
  //       <BreadcrumbsItem />
  //     </ContainerCustom>
  //   )
  // }
  if (removeContainer) {
    return <BreadcrumbsItem includeContainer={false} />
  }

  return <BreadcrumbsItem />
}
